// Leaf module — MUST have zero imports. getAppType() calls getFromLS during module
// evaluation; importing these through commonHelpers' circular import graph
// (commonHelpers ↔ OfflineAppHelper) caused a "Cannot access 'x' before
// initialization" boot crash on ChromeOS (bundle-order TDZ) — dev PR #6681.
export const getFromLS = (key: string): string | null => {
  return localStorage.getItem(key);
};

export const deleteFromLS = (key: string): void => {
  localStorage.removeItem(key);
};

export function setToLS(key: string, value: string | null): void {
  if (value === null) {
    localStorage.removeItem(key);
  } else {
    localStorage.setItem(key, value);
  }
}
